import { CaretDown } from '@phosphor-icons/react';
import { useState } from 'react';

const FAQSContent: {
	question: string | React.ReactNode;
	answer: string | React.ReactNode;
}[] = [
	{
		question: '¿Cuándo se va a presentar mi declaración anual?',
		answer: `Tu declaración anual se presentará entre el 1 y el 30 de abril de 2025.`,
	},
	{
		question: '¿Qué ingresos y deducciones incluyen en la declaración anual?',
		answer: (
			<p>
				Se incluyen todos los ingresos y deducciones que obtuviste en el año
				fiscal inmediatamente anterior, es decir, el 2024.{' '}
				<a
					className='text-h-primary-50'
					href='https://noticias.heru.app/en/articles/5360705'
					target='_blank'
				>
					Click aquí para ver el artículo
				</a>{' '}
			</p>
		),
	},
	{
		question:
			'¿Puedo utilizar mi saldo a favor mensual en la declaración anual?',
		answer: (
			<p>
				No, los saldos a favor solo se compensan contra impuestos de la misma
				naturaleza. <b>El saldo a favor mensual es de IVA,</b> y en la
				declaración anual no se presenta IVA, sino ISR. El saldo a favor o en
				contra de la anual corresponde al ISR.
			</p>
		),
	},
	{
		question: '¿Qué pasa si tengo declaraciones pendientes en el 2024?',
		answer: `Es muy importante que regularices todas tus declaraciones mensuales del 2024 para poder presentar tu declaración anual. La razón de esto es que tu declaración anual básicamente es el consolidado de todas tus declaraciones mensuales, así que sin las mismas no podremos presentar correctamente tu anual.`,
	},
	{
		question:
			'¿Necesito enviar algo a heru para que presenten mi declaración anual?',
		answer: `No, no te preocupes. No necesitas enviarnos documentos adicionales. Toda la información que necesitamos para presentar tu declaración anual la obtendremos de la información fiscal disponible en el SAT.`,
	},
	{
		question:
			'Si tengo más de un régimen fiscal, ¿debo presentar varias declaraciones anuales',
		answer: `No, el SAT exige una única declaración anual que integre todos tus regímenes fiscales, incluyendo ingresos y deducciones de todas tus fuentes. Para presentarla, debes estar al día en todas tus declaraciones mensuales por cada régimen que tengas. En heru, consolidamos toda tu información fiscal en una sola declaración.`,
	},
	{
		question: 'Si tengo saldo a favor, ¿cuándo me lo devuelve el SAT?',
		answer: `Si resultas con saldo a favor, el SAT debe devolverte el dinero dentro de un plazo máximo de 40 días naturales, siempre que no haya inconsistencias en tu declaración. Nosotros estaremos atentos a tu solicitud de devolución. También podrás hacer seguimiento a través de tu buzón tributario.`,
	},
	{
		question: '¿De qué depende el resultado de mi declaración anual?',
		answer: `El resultado de tu declaración anual depende directamente de la relación entre tus ingresos y deducciones durante el año fiscal 2024. En heru, nos encargamos de declarar correctamente todos tus ingresos y aplicar las deducciones a las que tienes derecho, asegurando que el resultado, ya sea un saldo a pagar o a favor, sea el adecuado y conforme a la normativa fiscal.`,
	},
	{
		question: '¿Qué pasa si tengo saldo a pagar?',
		answer: `Si resultas con saldo a pagar, el SAT te permitirá pagar de contado o en cuotas. En caso de que elijas pagar en cuotas, el SAT te permitirá hacerlo en un máximo de 6 cuotas. Ten en cuenta que la cantidad de cuotas puede variar de acuerdo al monto a pagar.`,
	},
];

export const AnnualFAQs = ({
	faqs = FAQSContent,
}: {
	faqs?: typeof FAQSContent;
}) => {
	// State to track which FAQ items are expanded
	const [expandedFaqs, setExpandedFaqs] = useState<number[]>([]);

	// Toggle FAQ expansion
	const toggleFaq = (faqId: number) => {
		setExpandedFaqs((prev) =>
			prev.includes(faqId)
				? prev.filter((id) => id !== faqId)
				: [...prev, faqId],
		);
	};
	return (
		<div className='w-full flex flex-col gap-2'>
			{faqs.map((faq, index) => (
				<div
					key={`faq-${index}`}
					className='border border-h-neutral-90 rounded-lg overflow-hidden'
				>
					<button
						onClick={() => toggleFaq(index)}
						className='w-full px-4 py-3 flex justify-between items-center bg-h-neutral-97 hover:bg-h-neutral-95 transition-colors'
					>
						<span className='font-medium text-left'>{faq.question}</span>
						<CaretDown
							size={20}
							className={`text-h-medium transition-transform duration-200 ${
								expandedFaqs.includes(index) ? 'rotate-180' : ''
							}`}
						/>
					</button>
					{expandedFaqs.includes(index) && (
						<div className='px-4 py-3 bg-white text-h-medium text-sm whitespace-pre-wrap'>
							{faq.answer}
						</div>
					)}
				</div>
			))}
		</div>
	);
};
